// components/ErrorBoundary.tsx
'use client';

import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

function ErrorFallback({ error }) {
  console.log(error)
  return (
            <div className="font-onest bg-[#1453FF1A] sm:bg-[#fff] min-h-[120vh] ">
              <Image
                src="/hack-logo.png"
                alt="hack the jobs logo"
                width={180}
                height={52}
                className="cursor-pointer mx-auto py-[20px] xm:pb-[0px] xm:px-4"
              />
              <div className="min-h-[70vh] flex justify-center items-center">
                <div className="max-w-[683px] bg-[#fff] rounded-[24px] p-[80px] lg:p-[60px] md:p-[24px]">
                  <h2 className="font-bold text-[40px] leading-[130%] tracking-[0] text-center mb-[16px]">
                    Oops
                  </h2>
                  <p className="font-medium text-[18px] leading-[150%] tracking-[0] text-center mb-[64px]">
                    Something went wrong <span>{error.message}</span>
                  </p>
                  {/* <button
                    onClick={() => reset()}
                    className="w-[276px] h-[48px] font-medium text-[16px] text-[#fff] leading-[24px] tracking-[0] bg-[#1453FF] py-[12px] px-[20px] rounded-[8px] block mx-auto"
                  >
                    Please Try Again
                  </button> */}
                </div>
              </div>
            </div>
  );
}

export default function ErrorBoundary({ children }) {
  return (
    <ReactErrorBoundary FallbackComponent={ErrorFallback}>
      {children}
    </ReactErrorBoundary>
  );
}
